module.exports = __webpack_public_path__ + "img/5.211f967b.png";